import React from 'react';
import BottomNavigation from './ui/BottomNavigation';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="relative min-h-screen bg-gray-50 dark:bg-dark-bg pb-20">
      {children}
      <BottomNavigation />
    </div>
  );
};

export default MainLayout;
